<mat-card-title class="d-flex align-items-center">
  <mat-icon class="mr-2">work</mat-icon>
  {{ title }}
</mat-card-title>
<mat-card-subtitle class="popup-subtitle">{{ dateRange }}</mat-card-subtitle>

<mat-divider class="mb-3"></mat-divider>

<mat-dialog-content>
  <div class="body-style">{{ description }}</div>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end">
  <div>
    <button mat-button (click)="onClickClose()">
      {{ 'pages.notices.view-notice.close-btn' | translate }}
    </button>
  </div>
</mat-dialog-actions>
